import type { SignalType } from "../../lib/types";
import { cn } from "../../lib/cn";

interface Props {
  type: SignalType;
  size?: "sm" | "md";
}

const styles: Record<SignalType, string> = {
  NEW_HIGH_IMPACT_BILL: "bg-signal-new-bg text-signal-new",
  STATUS_CHANGE:        "bg-signal-status-bg text-signal-status",
  EMERGING_RISK:        "bg-signal-emerging-bg text-signal-emerging",
};

const labels: Record<SignalType, string> = {
  NEW_HIGH_IMPACT_BILL: "New High-Impact",
  STATUS_CHANGE:        "Status Change",
  EMERGING_RISK:        "Emerging Risk",
};

export default function SignalTypeBadge({ type, size = "md" }: Props) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full font-semibold uppercase tracking-wide",
        size === "sm" ? "px-2 py-0.5 text-2xs" : "px-2.5 py-1 text-2xs",
        styles[type]
      )}
    >
      {labels[type]}
    </span>
  );
}
